import React, { Component } from "react";
import PropTypes from "prop-types";
import "./SplitPanel.css"

export default class SplitPanel extends Component {

    static propTypes = {
        left: PropTypes.node.isRequired,
        right: PropTypes.node.isRequired
    }

    render() {
        const { left, right } = this.props;
        return (
            <div className="SplitPanel">
                <div className="SplitPanel-panel">
                    {left}
                </div>
                <div className="SplitPanel-panel">
                    {right}
                </div>
            </div>
        );
    }

}